<script lang="ts">
  import { t } from 'svelte-i18n';
  import Button from '../../shared/button.svelte';
  import { checkInitialHeaderColors } from '../../shared/header-store';
  import { setModalHash } from '../../shared/modal-store';
  import { scrollTo, trackEvent } from '../../shared/utils';

  export let title: string;
  export let firstButton: string;
  export let secondButton: string;
  export let slide: number;
  export let preventAction = false;

  function checkAfterClick() {
    setTimeout(() => {
      checkInitialHeaderColors();
    }, 0);
  }

  function openEmailFormModal() {
    if (preventAction) {
      return;
    }

    trackEvent('open_form_squares', 'engagement', `contact_form`)

    setModalHash('contact-form');
  }

  function scrollToWorkingTogether() {
    if (preventAction) {
      trackEvent('home_see_more', 'click', `first slide`)
      return;
    }

    trackEvent('skip_to_our_process', 'click', `on_slide_${slide}`)
    
    const titleGap = 24;
    const screenWidth = screen.width;     
    const desktopGap = screenWidth > 1024 ? 72 : 0;
    const squaresContainer: HTMLElement = document.querySelector('.c-animated-flow');
    const offsetHeightSquares = squaresContainer.offsetHeight;

    scrollTo({ top: (offsetHeightSquares + desktopGap) - titleGap, behavior: 'smooth' });
    playVideo();
  }

  function playVideo() {
    const video: HTMLVideoElement = document.querySelector('#home-video');

    if (!video) {
      return;
    }

    video.play();
  }
</script>

<h1
  class="w-[262px] xs:w-[266px] sm:w-[328px] md:w-[356px] md2:w-[343px] md3:w-[380px] lg:w-[440px] xl:w-[576px] text-center md2:text-left pb-[24px] xs:pb-[32px] sm:pb-[40px] md2:pb-[48px]"
>
  <span>{$t(title)}</span>
</h1>
<div class="flex items-center justify-center flex-col md:flex-row md2:justify-start w-[262px] xs:w-[266px] sm:w-[328px] md:w-[495px] md2:w-[495px] md3:w-[380px] lg:w-[440px] xl:w-[576px]">
  {#if firstButton}
    <a class="md:mr-4 " on:click={openEmailFormModal} on:click={checkAfterClick} id="open_form_first">
      <Button short="true" variant="blue">
        <span class="text-base sm:text-xxs lg:text-xs">{$t(firstButton)}</span>
      </Button>
    </a>
  {/if}
  
  {#if secondButton}
    <a class={`${firstButton ? 'mt-4' : 'mt-0' } ${preventAction ? 'cursor-default' : 'cursor-pointer' } mt-4 md:mt-0`} on:click={scrollToWorkingTogether} on:click={checkAfterClick}>
      <Button variant="link" cursor={preventAction ? 'default' : 'pointer' }>
        {#if preventAction}<img class="scroll-animation mr-2" src="animations/scroll.gif"> {/if}
        <span class="flex items-center text-base sm:text-xxs lg:text-xs" class:underline={!preventAction}>{$t(secondButton)} {#if !preventAction}<ion-icon class="ml-2 text-xs md:text-md text-blue-dark" name="arrow-down"></ion-icon> {/if}</span>
      </Button>
    </a>
  {/if}
</div>

<style>
  .scroll-animation {
    /** The size here does not match with design spec, as the .lottie animation has some padding*/
    width: 24px;
    height: 24px;
    object-fit: contain;

    /** flip the animation to mimic the scroll gesture*/
    transform: rotateZ(180deg);
  }
</style>